import { ApiProperty } from '@nestjs/swagger'
import { IsEnum } from 'class-validator'
import { PedagogicContentState } from '../../enums/content.enum'

/**
 * DTO pour changer l'état d'un contenu pédagogique
 */
export class SetStateDto {
  @ApiProperty({
    description: 'Nouvel état du contenu',
    enum: PedagogicContentState,
    example: PedagogicContentState.ACTIVE,
  })
  @IsEnum(PedagogicContentState)
  state!: PedagogicContentState
}
